import { AgGridColumnProps } from "ag-grid-react";
import { asDate } from "lqx-react/src";
import { getAssetErrors, getAssetStatus, getCellColor } from "../components/assets-table";
import { asTimelessDateUTC } from "lqx-react/lib";

export enum FilterName {
    UniqueKey = 'uniqueKeys',
    CustomerNumber = 'customerNumbers',
    CustomerName = 'customerNames',
    CountryCode = 'countryCodes',
    EffectiveDate = 'effectiveDates',
    CompanyCode = 'companyCodes',
    GlobalParentCode = 'globalParentCodes',
    BankruptcyFlag = 'bankruptcyFlags',
    DunsNumber = 'dunsNumbers',
    Region = 'regions'
}

export enum FilterTypeCustomerReferenceData {
    All = 0,
    ValidationCategory,
    AssetState,
    UniqueKey,
    CustomerNumber,
    CustomerName,
    CountryCode,
    EffectiveDate,
    CompanyCode,
    GlobalParentCode,
    BankruptcyFlag,
    DunsNumber,
    Region
}

export enum CustomerReferenceDataSortingBase {
    Id = 0,
    CreatedOn,
    UpdatedOn,
    ValidationCategory,
    AssetState,
    UniqueKey,
    CustomerNumber,
    CustomerName,
    CountryCode,
    EffectiveDate,
    CompanyCode,
    GlobalParentCode,
    BankruptcyFlag,
    DunsNumber,
    Region
}

export enum CustomerReferenceDatasTableColumns {
    Status = 0,
    UniqueKey,
    CustomerNumber,
    CustomerName,
    CountryCode,
    EffectiveDate,
    CompanyCode,
    GlobalParentCode,
    BankruptcyFlag,
    DunsNumber,
    Region,
    Errors
}

export const CustomerReferenceDataTableColumns: AgGridColumnProps[] = [
    {
        colId: 'CheckBox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.Status.toString(),
        headerName: "Status",
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Pass Validation - New', 'Pass Validation - Modified', 'Require Review', 'Duplicated', 'Conflict', 'Saved for Later', 'Digitized', 'Modifies Existing']
        },
        valueGetter: params => getAssetStatus(params.data),
        cellStyle: params => { return { color: getCellColor(params.data) } },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.Errors.toString(),
        headerName: "Errors",
        valueGetter: params => getAssetErrors(params.data)
    },
    {
        colId: CustomerReferenceDatasTableColumns.UniqueKey.toString(),
        headerName: "Unique Key",
        field: "changes.uniqueKey",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.CustomerNumber.toString(),
        headerName: "Customer Number",
        field: "changes.customerNumber",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.CustomerName.toString(),
        headerName: "Customer Name",
        field: "changes.customerName",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.CountryCode.toString(),
        headerName: "Country Code",
        field: "changes.countryCode",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.EffectiveDate.toString(),
        headerName: "Effective Date",
        field: "changes.effectiveDate",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.CompanyCode.toString(),
        headerName: "Company Code",
        field: "changes.companyCode",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.GlobalParentCode.toString(),
        headerName: "Global Parent Code",
        field: "changes.globalParentCode",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.BankruptcyFlag.toString(),
        headerName: "Bankruptcy Flag",
        field: "changes.bankruptcyFlag",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.DunsNumber.toString(),
        headerName: "Duns Number",
        field: "changes.dunsNumber",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: CustomerReferenceDatasTableColumns.Region.toString(),
        headerName: "Region",
        field: "changes.region",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }
]